"use strict";

let productData = JSON.parse($("#productData").val());

function updateQuantityButton() {
    var quantityInput = $('input[name$="quantityQuick"]');
    var DEFAULT_AVAILABLE_COUNT = 10;
    var availableCount = DEFAULT_AVAILABLE_COUNT;

    if (
        productData &&
        productData.availableToSell &&
        productData.availableToSell.quantity !== undefined &&
        productData.availableToSell.quantity !== null
    ) {
        var qty = parseInt(productData.availableToSell.quantity, 10);
        if (!isNaN(qty)) {
            availableCount = qty;
        }
    }

    quantityInput.attr("data-available", availableCount);
    quantityInput.prop("max", availableCount);

    if (quantityInput.val() > availableCount) {
        quantityInput.val(availableCount);
    }

    var currentQuantityValue = parseInt($(".pz-quantity-select").val());

    //Initalize buttons
    $(".quantity-selector")
        .find(".btn-quantity.add")
        .removeClass("btn-qty-disabled");
    $(".quantity-selector")
        .find(".btn-quantity.sub")
        .removeClass("btn-qty-disabled");

    if (productData.readyToOrder) {
        // Disable plus button on max quantity
        if (availableCount === currentQuantityValue) {
            $(".quantity-selector")
                .find(".btn-quantity.add")
                .addClass("btn-qty-disabled");
        }
        // Disable minus button on min quantity
        if (productData.minOrderQuantity >= currentQuantityValue) {
            $(".quantity-selector")
                .find(".btn-quantity.sub")
                .addClass("btn-qty-disabled");
        }
    } else {
        $(".quantity-selector")
            .find(".btn-quantity.add")
            .addClass("btn-qty-disabled");
        $(".quantity-selector")
            .find(".btn-quantity.sub")
            .addClass("btn-qty-disabled");
    }
    // AZ-10527 L&F Quantity END
}

module.exports = {
    updateQuantityButton: updateQuantityButton,
};
